import { DateField, RecordContextProvider } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MobileListRow } from "features/MobileListRow";
import EmployeesField from "server/components/Fields/EmployeesField";
import { settings } from "app";
import { formatDays } from "./formatDays";

const VacationPeriodsMobileExpanded = ({ record }) => {
  const periods = record?.periods || [];

  return (
    periods.length > 1 && (
      <Accordion sx={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
          <Typography sx={{ fontWeight: "bold" }}>Периоди</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ width: "100%" }}>
          {periods.map((item, idx) => (
            <div
              key={idx}
              style={settings.style.shadowBoxMobile}
            >
              <MobileListRow
                fields={[
                  { label: "Начална дата", value: <DateField source="dateFrom" record={item} locales="bg-BG" /> },
                ]}
              />
              <MobileListRow
                fields={[{ label: "Крайна дата", value: <DateField source="dateTo" record={item} locales="bg-BG" /> }]}
              />
              <MobileListRow fields={[{ label: "Работни дни", value: formatDays(item.numberOfDays) }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Заместник",
                    value: (
                      <RecordContextProvider value={item}>
                        <EmployeesField source="substituteEmployeeId" />
                      </RecordContextProvider>
                    ),
                  },
                ]}
              />
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default VacationPeriodsMobileExpanded;
